
export default[
    {
        show(row,extra){
            return row.shbj==='0'
        },
        tag:'my-btn',
        type:'del',
        text:'删除',
        click(row,extra){
            this.$post(`${this.getGetters('mngUrl')}/DingBiao/ZbHxr/del.json`,{
                zhhxrcode:row.zhhxrcode
            }, (data, res) => {
                ShowMsg('删除成功','success')
                this.$emit('reload')
            });
            
        }
    },{
        show(row,extra){
            return row.shbj==='0'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改',
        click(row,extra){
            this.goto({
                path: '/bidding/projectflow/dingbiao/zbhxr/form',
                query: {
                    zhhxrcode: row.zhhxrcode,
                }
            });
        }
    },{
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'my-btn',
        type:'detail',
        text:'查看详情',
        click(row,extra){
            this.goto({
                path: '/bidding/projectflow/dingbiao/zbhxr/detail',
                query: {
                    zhhxrcode: row.zhhxrcode,
                }
            });
        }
    },
]